import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M13.4981 22.5L13.4981 4.71L20.0381 10.155C20.3444 10.4096 20.7394 10.5321 21.136 10.4955C21.5326 10.459 21.8985 10.2663 22.1531 9.96C22.4077 9.65368 22.5302 9.25875 22.4937 8.86211C22.4571 8.46548 22.2644 8.09961 21.9581 7.845L12.9581 0.345C12.8865 0.294541 12.8113 0.249419 12.7331 0.209999C12.6581 0.209999 12.6131 0.21 12.5381 0.105C12.3661 0.03701 12.1831 0.00141123 11.9981 -4.59052e-07C11.8132 0.00141121 11.6301 0.03701 11.4581 0.105C11.3831 0.105 11.3381 0.104999 11.2631 0.209999C11.1849 0.249418 11.1097 0.294541 11.0381 0.345L2.03812 7.845C1.8688 7.98603 1.73263 8.16264 1.6393 8.36227C1.54596 8.56189 1.49776 8.77963 1.49812 9C1.49744 9.35048 1.6195 9.69013 1.84312 9.96C1.96904 10.1119 2.1237 10.2374 2.29822 10.3295C2.47274 10.4215 2.6637 10.4782 2.86016 10.4963C3.05663 10.5144 3.25474 10.4936 3.44314 10.435C3.63155 10.3765 3.80655 10.2813 3.95812 10.155L10.4981 4.71L10.4981 22.5C10.4981 22.8978 10.6562 23.2794 10.9375 23.5607C11.2188 23.842 11.6003 24 11.9981 24C12.3959 24 12.7775 23.842 13.0588 23.5607C13.3401 23.2794 13.4981 22.8978 13.4981 22.5Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
